import React, { useRef, useState, useEffect } from 'react';

const InputAssinatura = (props) => {
	const canvasRef = useRef(null);
	const [isAssinando, setIsAssinando] = useState(false);
	
	useEffect(() => {
		const canvas = canvasRef.current;
		const ctx = canvas.getContext('2d');
		ctx.lineWidth = 2;
		ctx.lineCap = 'round';
		ctx.strokeStyle = 'black';
	}, []);
	
	const iniciarAssinatura = (offsetX, offsetY) => {
		const ctx = canvasRef.current.getContext('2d');
		ctx.beginPath();
		ctx.moveTo(offsetX, offsetY);
		setIsAssinando(true);
	};
	
	const assinatura = (e) => {
		if (!isAssinando) return;
		const { offsetX, offsetY } = e.nativeEvent;
		const ctx = canvasRef.current.getContext('2d');
		ctx.lineTo(offsetX, offsetY);
		ctx.stroke();
	};
	const finalizarAssinatura = () => {
		const ctx = canvasRef.current.getContext('2d');
		ctx.closePath();
		setIsAssinando(false);
	};
	
	const handleTouchStart = (e) => {
		const rect = canvasRef.current.getBoundingClientRect();
		const x = e.touches[0].clientX - rect.left;
		const y = e.touches[0].clientY - rect.top;
		iniciarAssinatura(x, y);
	};
	const handleTouchMove = (e) => {
		e.preventDefault(); // Prevent scrolling while drawing
		const rect = canvasRef.current.getBoundingClientRect();
		const x = e.touches[0].clientX - rect.left;
		const y = e.touches[0].clientY - rect.top;
		assinatura(x, y);
	};
	
	const limparAssinatura = () => {
		const canvas = canvasRef.current;
		const ctx = canvas.getContext('2d');
		ctx.clearRect(0, 0, canvas.width, canvas.height);
		props.onChange(null);
	};
	
	const salvarAssinatura = () => {
		const canvas = canvasRef.current;
		const dataURL = canvas.toDataURL(); // Converter para base64
		props.onChange(dataURL);
	};

	const handleImageUpload = (event) => {
		const file = event.target.files[0];
		if (file) {
			const reader = new FileReader();
			reader.onload = (e) => {
				props.onChange(e.target.result);
			};
			reader.readAsDataURL(file);
		}
	};

  return (
	<div className='form-group'
		style={{
			display: 'flex',
			flexDirection: 'column',
			width: window.innerWidth < 500 ? window.innerWidth - 10 : 500
		}}>
		{props.label &&
		<label>{props.label}</label>}
		
		<canvas
			ref={canvasRef}
			width={window.innerWidth < 500 ? window.innerWidth - 10 : 500}
			height={100}
			style={{
				border: '2px solid #000',
				backgroundColor: '#ffffff',
				display: props.value ? 'none' : null
			}}
			onMouseDown={e => iniciarAssinatura(e.nativeEvent.offsetX, e.nativeEvent.offsetY)}
			onMouseMove={assinatura}
			onMouseUp={finalizarAssinatura}
			onMouseLeave={finalizarAssinatura}
			// onTouchStart={handleTouchStart}
        	// onTouchMove={handleTouchMove}
        	// onTouchEnd={finalizarAssinatura}
			/>
		
		{props.value &&
		<img
			style={{
				border: '2px solid #000',
				backgroundColor: '#ffffff',
				width: window.innerWidth < 500 ? window.innerWidth - 10 : 500,
				height: 100
			}}
			src={props.value} />}
	
		<div 
			style={{
				display: 'flex',
				flexDirection: 'row',
				paddingTop: 2
			}}>
				<input 
					id={props.idUploadAssinatura || 'uploadAssinatura'}
					type="file" 
					accept="image/*" 
					onChange={handleImageUpload}
					style={{ display: 'none' }} />
				
				<label 
					htmlFor={props.idUploadAssinatura || 'uploadAssinatura'}
					className='btn btn-block btn-warning btn-xs'
					style={{ marginTop: 0, marginLeft: 0, marginBottom: 0, marginRight: 1, cursor: 'pointer' }}>
					Selecionar Imagem
				</label>
			<button 
				type='button'
				class='btn btn-block btn-success btn-xs'
				onClick={salvarAssinatura}
				style={{ marginTop: 0, marginLeft: 0, marginBottom: 0, marginRight: 1 }}
				disabled={props.value}>
				Salvar
			</button>
			<button 
				type='button'
				class='btn btn-block btn-danger btn-xs'
				onClick={limparAssinatura}
				style={{ marginTop: 0, marginLeft: 1, marginBottom: 0, marginRight: 0 }}>
				Limpar
			</button>
		</div>
    </div>
  );
};

export default InputAssinatura;
